import React from "react";
import { $t } from '@/modules/i18n';

import Logo from '@uh/assets/images/logo_shopee_h.png';

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
    };

  }
  handleChange(e) {
    this.setState({
      lang: e.target.value,
    })
  }
  render() {
    const msg = this.props.Message;
    return (
      <nav className="navbar navbar-default navbar-expand-lg fixed-top">
        <button className="navbar-toggler" type="button" data-toggle="collapse" href="#navbarNavDropdown" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown"
          aria-expanded="false" aria-label="Toggle navigation">
          <span className="icon ios-arrow-up"></span>
        </button>
        <div className="nav-logo-mobile">
          <img src="images/logo_shopee_v.png" alt="Company Logo" />
          {/* <h1 className="logo-text">National<br />Data Science<br />Challenge</h1> */}
          {/* <img src="images/logo_shopee_h.png" alt="Company Logo" /> */}
        </div>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <div className="container">
            <a className="nav-logo-desktop" href="/">
              <img src={Logo} alt="Company Logo" />
              {/* <h1 className="logo-text">National<br />Data Science<br />Challenge</h1> */}
            </a>
            <ul className="navbar-nav ml-auto" data-easing="easeInOutExpo" data-speed="1250" data-offset="65">
              <li className="nav-item">
                <a className="nav-link" href="#about">{$t(msg.navAbout)}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#timeline">{$t(msg.navTimeline)}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#prizes">{$t(msg.navPrizes)}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#theme">{$t(msg.navTheme)}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#judge">{$t(msg.navJudge)}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#faq">{$t(msg.navFaq)}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#partners">{$t(msg.navPartners)}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href={msg.careerLink} target="_blank" rel="noopener noreferrer">{$t(msg.career)}</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;